import types from "../../../../actionTypes";

export const TWO_FACTOR = types("TWO_FACTOR");
export const CLEAR_TWO_FACTOR = types("CLEAR_TWO_FACTOR");
